import React from 'react';
import VideoPlayer from './components/VideoPlayer';
import './App.css';

function App() {
  return (
    <div className="App">
      <VideoPlayer />
    </div>
  );
}

export default App;